import type { CSSProperties } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, Divider, Row } from '~/commonComponents';
import { WarningSolidIcon } from '~/images/icons';

interface ISuspendedBannerProps {
  counts: number;
  style?: CSSProperties;
}

export const SuspendedBanner = ({ counts, style }: ISuspendedBannerProps) => {
  if (counts === 0) {
    return null;
  }

  return (
    <Row
      alignItems="center"
      backgroundColor={colors.warning[30]}
      borderColor={colors.warning[700]}
      borderRadius={6}
      borderStyle="solid"
      borderWidth={1}
      gap={12}
      paddingBlock={12}
      paddingInline={10}
      marginInline={72}
      style={style}
    >
      <WarningSolidIcon color={colors.warning[500]} size={24} />
      <Divider height="95%" width={1} color={colors.warning[500]} />
      <Column>
        <Typography as="span" bold color={colors.warning[700]} style={{ marginBottom: 4 }}>
          Jobs Suspended, Update Payment Now
        </Typography>
        <Typography as="span" color={colors.warning[700]}>
          {counts} of your job postings have been suspended due to a failed payment. Please go to
          the Suspended tab to
          <br />
          update your payment method to prevent these jobs from being permanently closed.
        </Typography>
      </Column>
    </Row>
  );
};
